module InputTextRange {
	export function construct() {
		$("tbody tr input[type=text], tbody tr input[type=number]").keyup(handleInputChanged);
	}

	function handleInputChanged(event: JQuery.Event<HTMLElement, null>) {
		const changedInput = $(this);

		const selectedCells = TableRangeSelection.getSelectedCells(changedInput);
		if (selectedCells == null) {
			return;
		}
		const newValue = changedInput.val();

		selectedCells.forEach(function (td) {
			const input = td.find("input[type=text], input[type=number]");
			if (input.is(':disabled')) {
				return;
			}
			if (!input.is(changedInput)) {
				input.val(newValue);
				input.change();
			}
		});
	}
}

$(document).ready(() => {
	InputTextRange.construct();
});